/**
 * Created by laslo on 19.3.19..
 */

const e164Regex = /^\+[1-9]\d{5,15}$/

const _updateObject = (obj, paths, value) => {
  if (paths.length > 1){
    const newObjPath = paths.shift()
    let newObj = obj[newObjPath]
    if (!newObj) {
      newObj = {}
      obj[newObjPath] = newObj
    }
    _updateObject(newObj, paths, value)
  } else {
    obj[paths[0]] = value
  }
}

const _round = (value, places) => {
  const number = Number(value + ("e+"+places))
  return +(Math.round(number)  + ("e-"+places));
}

const _validateE164Number = (phoneNumber) => {
  return phoneNumber && e164Regex.test(phoneNumber)
}

export const updateObject = _updateObject
export const round = _round
export const validateE164Number = _validateE164Number


// WEBPACK FOOTER //
// ./src/utils/utils.js